import { render, staticRenderFns } from "./StudentAttendanceCards.vue?vue&type=template&id=2b7bea9e&"
import script from "./StudentAttendanceCards.vue?vue&type=script&lang=js&"
export * from "./StudentAttendanceCards.vue?vue&type=script&lang=js&"
import style0 from "./StudentAttendanceCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports